var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowLineDownLeft = function SvgIconArrowLineDownLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.75a1 1 0 0 0 0 2h16.5a1 1 0 1 0 0-2zM17.207 7.543a1 1 0 0 1 0 1.414L8.414 17.75h6.961a1 1 0 1 1 0 2H5.997a1 1 0 0 1-.702-.29l-.004-.005A1 1 0 0 1 5 18.75V9.375a1 1 0 0 1 2 0v6.96l8.793-8.792a1 1 0 0 1 1.414 0"
  }))));
};
export default SvgIconArrowLineDownLeft;